import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-medical',
  templateUrl: './add-medical.component.html',
  styleUrls: ['./add-medical.component.css']
})
export class AddMedicalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
